<script setup>

import {useLanguageStore} from "@/pinia";

const languageStore = useLanguageStore();
</script>

<template>
  <div class="deleteArea">
    <button class="deleteButton">{{languageStore.get('delete')}}</button>
  </div>
</template>

<style scoped>
.deleteButton{
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #C7C7C7;
  margin: 10px;
  min-width: 70px;
  height: 30px;
  padding: 0 12px;
  white-space: nowrap;
}
</style>